"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var system_1 = require("../system");
// @ts-ignore
var tooltip_arrow_dark_svg_1 = __importDefault(require("./assets/tooltip-arrow-dark.svg"));
// @ts-ignore
var tooltip_arrow_light_svg_1 = __importDefault(require("./assets/tooltip-arrow-light.svg"));
var common_1 = require("./common");
var systemColors = (_a = {},
    _a[system_1.SystemColors.BgMain] = 'rgba(48, 47, 45, 1)',
    _a[system_1.SystemColors.TextInvert] = 'rgba(33, 32, 31, 1)',
    _a[system_1.SystemColors.BgMinor] = 'rgba(66, 65, 62, 1)',
    _a[system_1.SystemColors.Divider] = 'rgba(255, 255, 255, 0.08)',
    _a[system_1.SystemColors.ButtonMinor] = 'rgba(92, 90, 87, 1)',
    _a[system_1.SystemColors.ControlMinor] = 'rgba(92, 90, 87, 1)',
    _a[system_1.SystemColors.Line] = 'rgba(117, 115, 111, 1)',
    _a[system_1.SystemColors.IconMinor] = 'rgba(138, 135, 132, 1)',
    _a[system_1.SystemColors.TextMinor] = 'rgba(158, 155, 152, 1)',
    _a[system_1.SystemColors.IconMain] = 'rgba(245, 244, 242, 1)',
    _a[system_1.SystemColors.TextMain] = 'rgba(245, 244, 242, 1)',
    _a[system_1.SystemColors.BgInvert] = 'rgba(245, 244, 242, 1)',
    _a[system_1.SystemColors.SubtleAccent] = 'rgba(64, 63, 58, 1)',
    _a[system_1.SystemColors.SelectedListItem] = 'rgba(250, 228, 54, 1)',
    _a[system_1.SystemColors.ButtonMain] = 'rgba(250, 194, 32, 1)',
    _a[system_1.SystemColors.ControlMain] = 'rgba(250, 194, 32, 1)',
    _a[system_1.SystemColors.Link] = 'rgba(132, 152, 250, 1)',
    _a[system_1.SystemColors.BgSuccess] = 'rgba(52, 199, 101, 1)',
    _a[system_1.SystemColors.TextSuccess] = 'rgba(52, 199, 101, 1)',
    _a[system_1.SystemColors.BgAttention] = 'rgba(253, 121, 79, 1)',
    _a[system_1.SystemColors.TextAttention] = 'rgba(253, 121, 79, 1)',
    _a);
var neutralColors = (_b = {},
    _b[system_1.NeutralColors.Text] = 'rgba(195,206,219,1)',
    _b[system_1.NeutralColors.BgGradient] = 'linear-gradient(148.65deg, #5B4B58 0%, #454D55 86.61%)',
    _b[system_1.NeutralColors.BgOpaque] = 'rgba(64,68,73,1)',
    _b[system_1.NeutralColors.BgTransparent] = 'rgba(85,91,98,0.6)',
    _b);
var colorsScheme = {
    system: systemColors,
    neutral: neutralColors,
};
var defaultButtonScheme = (0, common_1.buttonDefaultScheme)(colorsScheme);
var effectsScheme = {
    bottomShadow: '0px 8px 20px rgba(0, 0, 0, 0.4)',
    topShadow: '0px -8px 20px rgba(0, 0, 0, 0.4)',
    loadingGradient: "\n        linear-gradient(\n            90deg,\n            rgba(0, 0, 0, 0) 0,\n            rgba(0, 0, 0, 0.2) 20%,\n            rgba(0, 0, 0, 0.8) 60%,\n            rgba(0, 0, 0, 0)\n        )",
    overlayColor: '255,255,255',
};
var effects = (0, common_1.effectMixins)(effectsScheme);
var typography = (0, common_1.typographyMixins)(colorsScheme);
var paper = (0, common_1.paperMixin)(effects, typography, colorsScheme);
exports.theme = {
    schemes: {
        colors: colorsScheme,
        components: {
            buttons: (_c = {
                    default: defaultButtonScheme
                },
                _c[system_1.ButtonVariants.Main] = __assign(__assign({}, defaultButtonScheme), { textColor: colorsScheme.system.TextInvert }),
                _c),
            lists: {
                selectedTextColor: colorsScheme.system.TextInvert,
                selectedTextMinorColor: colorsScheme.system.TextInvert,
            },
            tooltips: {
                arrowPath: tooltip_arrow_dark_svg_1.default,
                invertArrowPath: tooltip_arrow_light_svg_1.default,
            },
            header: common_1.headerScheme,
        },
        spacing: {
            units: system_1.Spacing,
            spacingScheme12: common_1.spacingScheme12,
            spacingScheme15: common_1.spacingScheme15,
        },
        effects: effectsScheme,
        thickness: common_1.thicknessScheme,
    },
    mixins: {
        effects: effects,
        typography: typography,
        paper: paper,
    },
};
